import { render } from "./ActivityForm.vue?vue&type=template&id=3840e52c&scoped=true"
import script from "./ActivityForm.vue?vue&type=script&lang=js"
export * from "./ActivityForm.vue?vue&type=script&lang=js"

import "./ActivityForm.vue?vue&type=style&index=0&id=3840e52c&lang=less&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3840e52c"]])

export default __exports__